export default "__VITE_ASSET__05673a8b__"